// TODO(cms-email): potentially separate the allowed actions for SMS and Email
export enum CMSContentAction {
  SMS_INITIAL = 'SMS_INITIAL',
  SMS_LEFT_VOICEMAIL = 'SMS_LEFT_VOICEMAIL',
  SMS_NO_VOICEMAIL = 'SMS_NO_VOICEMAIL',
  SMS_MORE_INFO_RESPONSE = 'SMS_MORE_INFO_RESPONSE',
  SMS_MORE_INFO_RESPONSE_FOLLOW_UP = 'SMS_MORE_INFO_RESPONSE_FOLLOW_UP',
  SMS_FOLLOW_UP = 'SMS_FOLLOW_UP',
  SMS_HELP = 'SMS_HELP',
  EMAIL_INITIAL = 'EMAIL_INITIAL',
  EMAIL_FOLLOW_UP = 'EMAIL_FOLLOW_UP',
  // We do not want to support the reminder action just yet in the CMS, until we can finalize the
  // action+tone+template combinations that we want to support
  EMAIL_REMINDER = 'EMAIL_REMINDER',
}

export enum CMSContentTone {
  AUTHORITATIVE = 'AUTHORITATIVE',
  EASE = 'EASE',
  REWARDS = 'REWARDS',
  OUTCOMES = 'OUTCOMES',
  EMPATHETIC = 'EMPATHETIC',
  HANDWRITTEN = 'HANDWRITTEN',
  TEASER = 'TEASER',
}
